export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registration-by-login.vue?vue&type=template&id=ab886d50"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/quick-login-reg/registration-by-login.vue?vue&type=template&id=ab886d50
// module id = /nTy
// module chunks = 0